export const enGb = {
  accountDetailsDescription:
    "Bank account details like IBAN and Swift code (BIC). Account number, sort code or PIX key can be displayed for particular currencies.",
  add: "Add",
  backToAllBankAccount: "Back to all bank accounts",
  bankAccountNotFound: "Bank account not found",
  bankAccounts: "Bank accounts",
  cardSubtitleAccountsDetails:
    "Enter your account number (IBAN) and Swift code (BIC) to receive payments into this account",
  cardSubtitleAccountsDetailsGBP:
    "Creating a bank account in domestic currency in the United Kingdom requires providing the account number and sort code",
  cardSubtitleAccountsDetailsPIX:
    "Provide PIX identification key to receive domestic Brazilian settlement on this account",
  cardSubtitleAccountsDetailsUK:
    "Enter the international account number (IBAN) and Swift code (BIC)to receive payments into this account",
  cardTitleAccountDetails: "Account details",
  currency: "Currency",
  edit: "Edit",
  givenBankAccountCouldNotBeFound:
    "Given bank account could not be found. Make sure you are on correct mode (production/sandbox).",
  pixKey: "PIX Key",
  pixTypeCNPJ: "CNPJ",
  pixTypeEmail: "E-mail",
  pixTypePhoneNumber: "Phone number",
  pixTypeRandomKey: "Random key",
  swiftCode: "Swift code (BIC)",
};
